import styles from './OCRScopeJobDetailFooter.module.css'
import { Button } from '@/components/Button'

export interface OCRScopeJobDetailFooterProps {
  archived: boolean
  isPending: boolean
  isErrorOccurred: boolean
  isUnderReview: boolean
  isReadyToSubmit: boolean
  canSubmitJob: boolean
  onDelete: () => unknown
  onRerun: () => unknown
  onLinkManually: () => unknown
  onSetReadyToSubmit: () => unknown
  onSubmit: () => unknown
}

export function OCRScopeJobDetailFooter({
  archived,
  isPending,
  isErrorOccurred,
  isUnderReview,
  isReadyToSubmit,
  canSubmitJob,
  onDelete,
  onRerun,
  onLinkManually,
  onSetReadyToSubmit,
  onSubmit,
}: OCRScopeJobDetailFooterProps) {
  return (
    <div className={styles.root}>
      <div className={styles.detailFooterLeftContainer}>
        {!archived && (
          <Button label="Delete" onPress={onDelete} isDisabled={isPending} />
        )}
      </div>

      <div className={styles.detailFooterRightContainer}>
        {isErrorOccurred && (
          <>
            <Button
              label="Rerun OCR"
              onPress={onRerun}
              isDisabled={isPending}
            />
            <Button
              label="Job Created Manually"
              variant="primary"
              onPress={onLinkManually}
              isDisabled={isPending}
            />
          </>
        )}

        {isUnderReview && (
          <Button
            label="Set As Ready To Submit"
            variant="primary"
            onPress={onSetReadyToSubmit}
            isDisabled={isPending}
          />
        )}

        {isReadyToSubmit && (
          <Button
            label="Submit"
            variant="primary"
            isDisabled={!canSubmitJob || isPending}
            onPress={onSubmit}
          />
        )}
      </div>
    </div>
  )
}
